import { render, staticRenderFns } from "./LandscapeCard.vue?vue&type=template&id=4ed816d2&scoped=true"
import script from "./LandscapeCard.vue?vue&type=script&lang=js"
export * from "./LandscapeCard.vue?vue&type=script&lang=js"
import style0 from "./LandscapeCard.vue?vue&type=style&index=0&id=4ed816d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed816d2",
  null
  
)

export default component.exports